import get from 'lodash/get';
import snakeCase from 'lodash/snakeCase';

export const FieldItemMixin = {
    inject: ['store'],
    mounted() {
        const config = this.store.getSettingConfig(this.fieldName);
        if (config) config.active = true;
    },
    destroyed() {
        const config = this.store.getSettingConfig(this.fieldName);
        if (config) config.active = false;
    },
    computed: {
        fieldConfig() {
            return this.store.getSettingConfig(this.fieldName);
        },
        fieldValue: {
            get() {
                const external = this.store.isExternalField(this.fieldName);
                const setting = external ? this.store.externalSetting : this.store.searchSetting;
                return get(
                    this.store.settingValues,
                    this.fieldName,
                    this.fieldConfig.getValue(setting),
                );
            },
            set(val) {
                this.store.$set(this.store.settingValues, this.fieldName, val);
            },
        },
        id() {
            return [
                'bio_setting',
                this.store.searchType,
                this.fieldName,
            ].map(snakeCase).join('-');
        },
    },
    methods: {
        syncChange() {
            this.fieldValue = this.fieldConfig.format(this.fieldValue);
            this.store.writeFieldValue(this.fieldName);
        },
        isNumber(ev) {
            const charCode = ev.keyCode;
            // char code 48 对应 0， char code 57 对应 9， > 31 表示可显示字符
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                ev.preventDefault();
            }
            return true;
        },
    },
};
